import { useEffect, useState } from "react";

import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import CategoryHead from "@/components/Category/CategoryHead";
import Pagination from "@/components/Common/Pagination";
import { Drawer, ButtonToolbar, Button, Placeholder } from "rsuite";
import CourseDetails from "../../data/course-details/courseData.json";
//components/Category/
// import courseData from "../../components/Category/Filter/courseData.json";
import BackToTop from "../backToTop";
// import CourseTabs from "@/components/Category/Filter/CourseTabs";
import FooterThree from "@/components/Footer/Footer-Three";
import {
  CountryNames,
  CourseNames,
  SubjectNames,
  getData,
  postData,
} from "@/Action/api";
// import CourseSidebar from "@/components/Category/FIlter/CourseSidebar";
import CourseTabs from "@/components/Category/FIlter/CourseTabs";
import CourseSidebar from "@/components/Category/FIlter/CourseSidebar";

const StudyCourses = () => {
  // const [courses, setCourse] = useState([]);
  const [page, setPage] = useState(1);
  const [isSelected, setIsSelected] = useState({
    courses: [],
    studylevel: [],
    studydestination: [],
  });
  const [open, setOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subjectAreaData, setSubjectAreaData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [Projects, setProjects] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const fetchData = async (currentPage = 1, q = searchQuery) => {
    setLoading(true);

    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);

      const parseParam = (param) => {
        if (!param) return [];
        return param.split(",").map(Number).filter(Boolean);
      };

      const subjectid = parseParam(searchParams.get("subjectid"));
      const studylevel = parseParam(searchParams.get("studylevel"));
      const country = parseParam(searchParams.get("country"));
      const urlQ = searchParams.get("q") || "";
      const finalQ = q || urlQ;

      const data = {};

      if (subjectid.length || isSelected?.courses?.length) {
        data.subjectid = [...subjectid, ...(isSelected?.courses || [])].filter(
          (item) => item !== null,
        );
      }

      if (studylevel.length || isSelected?.studylevel?.length) {
        data.studylevel = [
          ...studylevel,
          ...(isSelected?.studylevel || []),
        ].filter((item) => item !== null);
      }

      if (country.length || isSelected?.studydestination?.length) {
        data.country = [
          ...country,
          ...(isSelected?.studydestination || []),
        ].filter((item) => item !== null);
      }

      if (finalQ) data.q = finalQ;

      try {
        const navData = await postData(
          `/get/courses?size=12&page=${currentPage}`,
          data,
        );
        setProjects(navData?.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const urlQ = new URLSearchParams(window.location.search).get("q") || "";
      if (urlQ) setSearchQuery(urlQ);
    }
    fetchData();
  }, []);

  let getAllCourse = JSON.parse(
    JSON.stringify(CourseDetails.courseDetails.slice(0, 12)),
  );
  let getAllCourses = JSON.parse(
    JSON.stringify(CourseDetails.courseDetails.slice(0, 12)),
  );
  const gradient1 =
    "linear-gradient(25deg, rgb(14, 20, 46) 50%, rgb(157, 86, 24) 100%)";
  const gradient2 =
    "linear-gradient(25deg, rgba(14, 20, 46, 1) 0%, rgba(16, 24, 113, 1) 100%)";
  const startIndex = (page - 1) * 6;

  const getSelectedCourse = [];

  const handleClick = async (num) => {
    await fetchData(num);
    setPage(num);
    // window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    (async () => {
      try {
        const result = await getData("get/subcategory");
        const studylevel_result = await SubjectNames();
        const destination_result = await CountryNames();
        const subject_area_data = await getData("get/category");

        setSubjectAreaData(subject_area_data?.data ?? []);
        setFilteredData([
          {
            Title: "Select Course",
            Data: result?.data?.map((item) => ({
              ...item,
              checkvalue: "courses",
            })),
            name: "courses",
          },
          {
            Title: "Select Study Level",
            Data: studylevel_result?.res?.data?.map((item) => ({
              ...item,
              checkvalue: "studylevel",
            })),
            name: "studylevel",
          },
          {
            Title: "Select Study Destination",
            Data: destination_result?.res?.data?.map((item) => ({
              ...item,
              checkvalue: "studydestination",
            })),
            name: "studydestination",
          },
        ]);
      } catch (err) {
        console.error(err);
      }
    })();
  }, {});

  const handleSubjectArea = async (value) => {
    try {
      const result = await getData(`get/subcategory/${value?.id}`);
      setFilteredData((prev) => {
        const updatedData = [...prev];
        updatedData[0] = {
          Title: "Select Course",
          Data: result?.data?.map((item) => ({
            ...item,
            checkvalue: "courses",
          })),
          name: "courses",
        };
        return updatedData;
      });

      setOpen(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const subjectid = searchParams.get("subjectid")
        ? [Number(searchParams.get("subjectid"))]
        : [];
      const studylevel = searchParams.get("studylevel")
        ? [Number(searchParams.get("studylevel"))]
        : [];
      const country = searchParams.get("country")
        ? [Number(searchParams.get("country"))]
        : [];

      setIsSelected({
        courses: subjectid,
        studylevel: studylevel,
        studydestination: country,
      });
    }
  }, []);

  useEffect(() => {
    let delayDebounceFn;

    delayDebounceFn = setTimeout(async () => {
      fetchData();
    }, 100);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line
  }, [isSelected]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchData(1, searchQuery);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line
  }, [searchQuery]);

  useEffect(() => {
    // setCourse(courseData);
    setTotalPages(Math.ceil(getAllCourse.length / 6));
    setTotalPages(Math.ceil(getAllCourses.length / 6));
  }, [setTotalPages]);

  return (
    <>
      <Drawer open={open} onClose={() => setOpen(false)} placement="left">
        <Drawer.Header>
          <Drawer.Title>
            <h4
              style={{
                paddingBottom: "0px",
                marginBottom: "0px",
              }}
            >
              Filter Course by Subject Area
            </h4>
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {/* <h5
            style={{
              // marginBottom: "0.5rem",
              // fontSize: "1.25rem",
              fontWeight: "bold",
              color: "#333",
            }}
          >
            Subject Area:
          </h5> */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
          >
            {subjectAreaData?.map((item, index) => (
              <div
                key={index}
                style={{
                  padding: "0.5rem 0",
                  // fontSize: "1rem",
                  fontWeight: "500",
                  color: "#555",
                  cursor: "pointer",
                  position: "relative",
                }}
                onMouseEnter={(e) => {
                  e.target.style.textDecoration = "underline";
                  e.target.style.color = "#DB6827"; // Highlight color on hover
                }}
                onMouseLeave={(e) => {
                  e.target.style.textDecoration = "none";
                  e.target.style.color = "#555"; // Reset color
                }}
                onClickCapture={() => {
                  handleSubjectArea(item);
                }}
              >
                {item?.name}
              </div>
            ))}
          </div>
        </Drawer.Body>
      </Drawer>
      <PageHead title="Course-Immigration Guru's"
        description="Explore study abroad courses in computer science, business, engineering, health sciences, law and more, with entry requirements and fees explained." />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <CategoryHead
            category={getAllCourse}
            courses={getAllCourses}
            navData={Projects}
          />
          <div className="rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <div className="row row--30 gy-5">
                <div className="col-lg-3 order-2 order-lg-1">
                  <CourseSidebar
                    isSelected={isSelected}
                    setIsSelected={setIsSelected}
                    Data={filteredData}
                    handleChangeSearch={() => {
                      setOpen(true);
                    }}
                    PlaceHolderValue="Select Area"
                    onSearch={setSearchQuery}
                  />
                </div>
                <div
                  className="col-lg-9 order-1 order-lg-2"
                  style={{
                    paddingLeft: "0px",
                    paddingRight: "0px",
                  }}
                >
                  <h2 className="title h4 mb--20">
                    Browse Study Abroad Courses
                  </h2>
                  <CourseTabs
                    Projects={Projects}
                    course={getSelectedCourse}
                    nameKey={"masterCourse"}
                  />
                </div>
              </div>
              {Projects?.pagination?.totalPages > 0 ? (
                <div className="row">
                  <div className="col-lg-12 mt--60">
                    <Pagination
                      totalPages={Projects?.pagination?.totalPages}
                      pageNumber={Projects?.pagination?.currentPage}
                      handleClick={handleClick}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          <BackToTop />
          <FooterThree />
        </Context>
      </Provider>
    </>
  );
};

export default StudyCourses;

export async function getServerSideProps() {
  try {
    // Static data (you can replace this with API calls or dynamic data)
    const result_data = {
      name: "John Doe",
      country: "USA",
      occupation: "Software Developer",
    };

    return {
      props: {
        result_data, // Passing static data as props to the component
      },
    };
  } catch (err) {
    console.error("Error:", err); // Log any error that occurs during data fetching
    return {
      notFound: true, // Gracefully handle any errors
    };
  }
}
